import React, { Component } from 'react';
import { useTranslations } from '../../locales/useTranslations';

const DatenschutzContent = () => {
    const { t } = useTranslations();

    return (
        <div className="text-container ptb-100">
            <div className="container">
                <h2>{t('datenschutz_page_title')}</h2>
                <br></br>
                <h3>{t('datenschutz_content_1_title')}</h3>
                <h4>{t('datenschutz_content_1_subtitle')}</h4>
                <br></br>


                <h4>{t('datenschutz_content_1_subtitle_1')}</h4>
                <p>{t('datenschutz_content_1_description_1')}</p>
                <p>{t('datenschutz_content_1_description_2')}</p>
                <br></br>

                <h4>{t('datenschutz_content_1_title2')}</h4>
                <h5>{t('datenschutz_content_1_subtitle2')}</h5>

                <p>{t('datenschutz_content_1_description2')}</p>

                <h5>{t('datenschutz_content_1_subtitle3')}</h5>

                <p>{t('datenschutz_content_1_description3')}</p>

                <h5>{t('datenschutz_content_1_subtitle4')}</h5>
                <p>{t('datenschutz_content_1_description4')}</p>

                <h5>{t('datenschutz_content_1_subtitle5')}</h5>
                <p>{t('datenschutz_content_1_description5')}</p>

                <h5>{t('datenschutz_content_1_subtitle6')}</h5>
                <p>{t('datenschutz_content_1_description6')}</p>
                <br></br>

                <h3>{t('datenschutz_content_1_title3')}</h3>
                <p>{t('datenschutz_content_1_description7')}</p>
                <h4>{t('datenschutz_content_1_subtitle3')}</h4>
                <p>{t('datenschutz_content_1_description8')}</p>

                <p>{t('datenschutz_content_1_description9')}</p>

                <p><b>{t('datenschutz_content_1_description10')}</b><br></br>
                    {t('datenschutz_content_1_description11')}<br></br>
                    {t('datenschutz_content_1_description12')}<br></br>
                    {t('datenschutz_content_1_description13')}<br></br></p>
                <p><b>{t('datenschutz_content_1_description14')}</b></p>
                <p>{t('datenschutz_content_1_description15')}</p>
                <br></br>

                <h3>{t('datenschutz_content_1_title4')}</h3>
                <h4>{t('datenschutz_content_1_subtitle4')}</h4>
                <p>{t('datenschutz_content_1_description16')}</p>
                <p>{t('datenschutz_content_1_description17')}</p>
                <p>{t('datenschutz_content_1_description18')}</p>
                <p>{t('datenschutz_content_1_description19')}</p>
                <p>{t('datenschutz_content_1_description20')}</p>
                <p>{t('datenschutz_content_1_description21')}</p>
                <p><b>{t('datenschutz_content_1_description22')}</b><br></br>
                    {t('datenschutz_content_1_description23')}<br></br>
                    {t('datenschutz_content_1_description24')}<br></br>
                    {t('datenschutz_content_1_description25')}<br></br>
                    {t('datenschutz_content_1_description26')}</p>
                <p>{t('datenschutz_content_1_description27')}</p>

                <h4>{t('datenschutz_content_1_subtitle5')}</h4>
                <p>{t('datenschutz_content_1_description28')}</p>

                <h4>{t('datenschutz_content_1_subtitle7')}</h4>
                <p>{t('datenschutz_content_1_description29')}</p>

                <h4>{t('datenschutz_content_1_subtitle8')}</h4>
                <p>{t('datenschutz_content_1_description30')}</p>

                <p>{t('datenschutz_content_1_description31')}</p>

                <h4>{t('datenschutz_content_1_subtitle9')}</h4>
                <p>{t('datenschutz_content_1_description32')}</p>

                <h4>{t('datenschutz_content_1_subtitle10')}</h4>
                <p>{t('datenschutz_content_1_description33')}</p>

                <h4>{t('datenschutz_content_1_subtitle11')}</h4>
                <p>{t('datenschutz_content_1_description34')}</p>

                <h4>{t('datenschutz_content_1_subtitle12')}</h4>
                <p>{t('datenschutz_content_1_description35')}</p>

                <h4>{t('datenschutz_content_1_subtitle13')}</h4>
                <p>{t('datenschutz_content_1_description36')}</p>

                <h4>{t('datenschutz_content_1_subtitle14')}</h4>
                <p>{t('datenschutz_content_1_description37')}</p>
                <ul>
                    <li>{t('datenschutz_content_1_description38')}</li>

                    <li>{t('datenschutz_content_1_description39')}</li>

                    <li>{t('datenschutz_content_1_description40')}</li>

                    <li>{t('datenschutz_content_1_description41')}</li>
                </ul>
                <p>{t('datenschutz_content_1_description42')}</p>

                <h4>{t('datenschutz_content_1_subtitle15')}</h4>
                <p>{t('datenschutz_content_1_description43')}</p>

                <h4>{t('datenschutz_content_1_subtitle16')}</h4>
                <p>{t('datenschutz_content_1_description44')}</p>

                <br></br>
                <h3>{t('datenschutz_content_1_title5')}</h3>
                <h4>{t('datenschutz_content_1_subtitle17')}</h4>

                <p>{t('datenschutz_content_1_description45')}</p>

                <p>{t('datenschutz_content_1_description46')}</p>

                <p>{t('datenschutz_content_1_description47')}</p>

                <p>{t('datenschutz_content_1_description48')}</p>

                <h4>{t('datenschutz_content_1_subtitle18')}</h4>
                <p>{t('datenschutz_content_1_description49')}</p>
                <ul>
                    <li>{t('datenschutz_content_1_description50')}</li>
                    <li>{t('datenschutz_content_1_description51')}</li>
                    <li>{t('datenschutz_content_1_description52')}</li>
                    <li>{t('datenschutz_content_1_description53')}</li>
                    <li>{t('datenschutz_content_1_description54')}</li>
                    <li>{t('datenschutz_content_1_description55')}</li>
                </ul>
                <p>{t('datenschutz_content_1_description56')}</p>

                <h4>{t('datenschutz_content_1_subtitle19')}</h4>
                <p>{t('datenschutz_content_1_description57')}</p>
                <p>{t('datenschutz_content_1_description58')}</p>

                <h4>{t('datenschutz_content_1_subtitle20')}</h4>
                <p>{t('datenschutz_content_1_description59')}</p>

                <br></br>
                <h3>{t('datenschutz_content_1_title6')}</h3>
                <h4>{t('datenschutz_content_1_subtitle21')}</h4>
                <p>{t('datenschutz_content_1_description60')}</p>

                <h4>{t('datenschutz_content_1_subtitle22')}</h4>
                <p>{t('datenschutz_content_1_description61')}</p>

                <br></br>
                <h3>{t('datenschutz_content_1_title7')}</h3>
                <h4>{t('datenschutz_content_1_subtitle23')}</h4>
                <p>{t('datenschutz_content_1_description62')}</p>

                <p>{t('datenschutz_content_1_description63')}</p>

            </div>
        </div >
    );
}

export default DatenschutzContent;
